module.exports = __webpack_public_path__ + "img/SharpnessEnhancement02.6c50e5ed.png";